import axios from "axios"
import Cookies from "js-cookie"
import { FIRMFLOWURL } from "./url";
const EMPLOYEE_REQUEST_TIMEOUT = 15000;
let inFlightEmployeeRequest = null;

export const getLoggedInEmployee = () => {
    if (inFlightEmployeeRequest) return inFlightEmployeeRequest;

    inFlightEmployeeRequest = (async () => {
        try {
            const token = Cookies.get('Bearer');
            const response = await axios.get(`${FIRMFLOWURL}api/Employee`,
                {
                    headers: { 'Authorization': token },
                    timeout: EMPLOYEE_REQUEST_TIMEOUT,
                }
            )
            return { ...response, success: true };
        } catch (err) {
            const status = err.response?.status;
            if (status === 401) {
                Cookies.remove('Bearer');
                window.location.replace('/');
            }
            return {
                success: false,
                status,
                message: err.response?.data?.message || err.message || "Request failed.",
            };
        }
    })().finally(() => {
        inFlightEmployeeRequest = null;
    });

    return inFlightEmployeeRequest;
}